export const userGroup = {
  //Please ensure that user(s) must have mentioned role(s) and permission(s) before running any test case(s).
  centralPMG: {
    PMG_User: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["PMG user"],
      permissions: ["Create state project", "Create central project"]
    },
    PMG_Admin: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["PMG Admin"],
      permissions: ["Create state project", "Create central project"]
    },
    PMG_SuperAdmin: {
      username: "rohitd",
      password: "Test@123",
      name: "Rohit Dua",
      groupCategory: "centralPMG",
      roles: ["PMG user", "PMG Admin", "PMG SuperAdmin"],
      permissions: ["Create state project", "Create central project"]
    }
  },
  statePMG: {
    username: "sanjaypatil",
    password: "Test@123",
    name: "Sanjay Patil",
    groupCategory: "statePMG",
    roles: ["State PMG"],
    permissions: ["Create state project"]
  },
  PP: {
    username: "Dharmendra",
    password: "Test@123",
    name: "Dharmendra",
    groupCategory: "PP",
    roles: ["PP"],
    permissions: ["Create central project"]
  },
  nodalOfficer: {
    username: "",
    password: "",
    name: "",
    groupCategory: "",
    roles: [],
    permissions: []
  },
  viewOnly: {
    centerUser: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["Center user"],
      permissions: []
    },
    stateUser: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["State user"],
      permissions: []
    }
  },
  central: {
    centralUser: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["Center user"],
      permissions: []
    },
    centerAdmin: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["Center user", "Center Admin"],
      permissions: []
    }
  },
  state: {
    stateUser: {
      username: "",
      password: "",
      name: "",
      groupCategory: "",
      roles: ["State user"],
      permissions: ["Create state project"]
    },
    stateAdmin: {
      username: "jtdirindustries",
      password: "Test@123",
      name: "S J Korbu",
      groupCategory: "state",
      roles: ["State Admin", "State user"],
      permissions: ["Create state project"]
    }
  }
};
